import { Box, Flex } from '@chakra-ui/react';

import { NOTIFICATION_EVENT_CHANNELS } from '../../constants/NotificationSettingsConstants';
import { FIXED_COLUMN_WIDTH } from './NetchexNotificationEventTable';

export const NetchexNotificationEventTableHeader = ({ channelDetailsMap = [] }) => (
  <Flex
    background="#F5F7F9"
    borderRadius="4px"
    minWidth={`calc(300px + ${FIXED_COLUMN_WIDTH * Object.values(channelDetailsMap).length}px)`}
  >
    <Box flex="1 1 auto" padding="8px" minWidth="300px">
      Topic
    </Box>
    <Box flex={`0 0 ${2 * FIXED_COLUMN_WIDTH}px`} textAlign="center" padding="8px">
      Supported
    </Box>

    {Object.values(channelDetailsMap)?.map(({ channelType }, index, array) => {
      const { name } = NOTIFICATION_EVENT_CHANNELS[channelType] ?? {};
      if (channelType === 'EMAIL') {
        return (
          <Box
            key={name}
            flex={`0 0 ${2 * FIXED_COLUMN_WIDTH}px`}
            padding="8px"
            borderTopRightRadius={index === array.length - 1 ? '4px' : '0'}
            borderBottomRightRadius={index === array.length - 1 ? '4px' : '0'}
            textAlign="center"
          >
            Notify
          </Box>
        );
      }
      return null;
    })}
  </Flex>
);
